// src/components/AddEditTaskModal.js
import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { CMS_WEBSITE_TYPE, PLATFORM_TYPE } from "../../utils/enum";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import { ValidateInputs } from "../../utils/helper";

const initialData = {
  question: "",
  answer: "",
  type: "",
};

const AddFaqModal = ({ show, handleClose, handleSave, task, faqs }) => {
  const isEdit = Boolean(task);
  const [data, setData] = useState(initialData);
  const [errors, setErrors] = useState({});

  const getFaq = () => {
    if (isEdit && task) {
      const currentFaq = faqs.find(
        (faq) => faq._id === task.id || faq._id === task._id
      );
      if (currentFaq) {
        const { question, answer, type } = currentFaq;
        setData({ question, answer, type });
      }
    } else {
      setData(initialData);
    }
  };

  useEffect(() => {
    getFaq();
  }, [isEdit, task, faqs, show]);

  useEffect(() => {
    if (!show) setData(initialData);
    if (!show) setErrors({});
  }, [handleClose, show]);

  // Validation function for FAQ fields
  const validateFaq = () => {
    console.log("faà")
    let newErrors = {};
    // Question validation
    if (!data.question.trim()) {
      newErrors.question = "Question is required";
    }
    // else if (!/^[a-zA-Z0-9\s.,!?]*$/.test(data.question.trim())) {
    //   newErrors.question = "Question cannot contain special characters";
    // }
    else if (data.question.trim().length < 10) {
      newErrors.question = "Question must be at least 10 characters long";
    }
    else if (data.question.trim().length > 100) {
      newErrors.question = "Question cannot exceed 100 characters";
    }
    // Answer validation
    if (!data.answer.trim()) {
      newErrors.answer = "Answer is required";
    } else if (data.answer.trim().length > 300) {
      newErrors.answer = "Answer cannot exceed 300 characters";
    }
    // type validation
    if (!data.type) {
      newErrors.type = "Platform type is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSave = () => {
    if (!validateFaq()) {
      return;
    }
    const taskData = {
      id: isEdit ? task.id : null,
      question: data.question,
      answer: data.answer,
      type: data.type,
    };

    handleSave(taskData, isEdit);
    setData(initialData);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name : ", name);
    console.log("value : ", value);
    setData((prev) => ({ ...prev, [name]: value }));
    // Live validation on change
    setErrors((prevErrors) => ValidateInputs(name, value, prevErrors));
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Faq" : "Add New Faq"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Question */}
          <Form.Group className="mb-3" controlId="taskQuestion">
            <Form.Label>Question</Form.Label>
            <Form.Control
              type="text"
              name="question"
              placeholder="Enter Question"
              value={data.question}
              onChange={handleChange}
              isInvalid={!!errors.question}
              required
            />
            {errors.question && (
              <Form.Control.Feedback type="invalid">
                {errors.question}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          {/* Platform Type Dropdown */}
          <Form.Group className="mb-3" controlId="taskTag">
            <Form.Label>Platform Type</Form.Label>
            <Form.Select
              name="type"
              value={data.type}
              onChange={handleChange}
              isInvalid={!!errors.type}
              required
            >
              <option value="">Select Platform Type</option>
              {Object.entries(PLATFORM_TYPE).map(([key, value]) => (
                <option key={key} value={value}>
                  {value
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </option>
              ))}
            </Form.Select>
            {errors.type && (
              <Form.Control.Feedback type="invalid">
                {errors.type}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          {/* Answer */}
          <Form.Group className="mb-3" controlId="taskDescription">
            <Form.Label>Answer</Form.Label>
            <Form.Control
              as="textarea"
              name="answer"
              rows={3}
              placeholder="Enter Answer"
              value={data.answer}
              onChange={handleChange}
              isInvalid={!!errors.answer}
              required
            />
            {errors.answer && (
              <Form.Control.Feedback type="invalid">
                {errors.answer}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddFaqModal;
